module.exports = __webpack_public_path__ + "static/ceed black-2f4166acd004f053fd1ffeaf3f7be471.png";